export default {
  signal: 'Signal',
  unit: 'Einheit',
  min: 'Min',
  max: 'Max',
  average: 'ȳ',
  standardDeviation: 'σ',
  cursor: 'cursor',
};
